export default "__VITE_ASSET__DWnSY5Nw__"